import axios from "axios";
import consts from "../consts";
import { initialize } from "redux-form";
import { setErroAPI, setSuccess } from "../common/toast/toast";

export function setModoTela(modo, registro = {}) {
    return {
        type: "PLATAFORMA_MERCADO_LIVRE_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "PLATAFORMA_MERCADO_LIVRE_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function initForm(registro = {}) {
    return [initialize("plataformaMercadoLivreForm", registro)];
}

export function salvar(registro) {
    const registroFormatado = { ...registro };
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            if (!registro.id) {
                await axios.post(`${consts.API_URL}/plataforma-mercado-livre`, registroFormatado);
            } else {
                await axios.put(`${consts.API_URL}/plataforma-mercado-livre`, registroFormatado);
            }
            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (erro) {
            setErroAPI(erro);
            dispatch(
                initForm({
                    ...registro,
                })
            );
        } finally {
            dispatch(setAguardando(false));
        }
    };
}


export function getLista() {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/plataforma-mercado-livre`);
            dispatch({
                type: "PLATAFORMA_MERCADO_LIVRE_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
